import { UnderlyingHistoModalConnected } from 'components/shared/UnderlyingHistos/UnderlyingHistoModal.connect';
import { UnderlyingTooltipIcon } from 'components/shared/UnderlyingInfo/underlying-tooltip-icon';
import { type Underlying } from 'models/underlying';
import type { EquityUnderlying } from 'models/underlying/equity';
import { useMemo } from 'react';

import { WithUnderlyingInfoTooltip } from './WithUnderlyingInfoTooltip';

export interface IUnderlyingInfoProps {
  underlying: Underlying;
}

export function UnderlyingInfo({ underlying }: IUnderlyingInfoProps) {
  const isEquity = underlying.asset === 'Equity';
  const underlyings = useMemo(
    () => [underlying].filter((u): u is EquityUnderlying => u.asset === 'Equity'),
    [underlying],
  );
  return (
    <div className="d-flex">
      {isEquity && <UnderlyingHistoModalConnected isDisabled={false} isMulti={false} underlyings={underlyings} />}
      <WithUnderlyingInfoTooltip underlying={underlying}>
        <UnderlyingTooltipIcon underlying={underlying} />
      </WithUnderlyingInfoTooltip>
    </div>
  );
}
